import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Keyboard, Platform, View} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
import {
  BottomTab,
  BottomTabButton,
} from 'src/Modules/TabViews/FooterComponents';

import {anyTimePhotoCompletion} from 'src/Utils/huntFunctions';

import isIphoneX from 'src/Utils/IphoneXHelper';
import {setCurrentGroupId} from 'src/Redux/reducers/user_info.reducer';
import {parsePlayerChallegeData} from 'src/Utils/dataHelper';

import {navigationRef} from 'src/Nav/navigationHelpers';
import {setLocationChallengeData} from '../Redux/reducers/game_v2.reducer';
import {
  updateAnytimePhotosData,
  updatePlayerChallengeData,
  updateTreasureChallengeData,
} from '../Redux/reducers/game.reducer';
import {setGroupInfo} from '../Redux/reducers/groupInfo.reducer';
import {dispatchAction} from '../Utils/helpers';
import {useFirebaseData} from '../Utils/fireUtils';
import {usePercentageComplete} from '../Hooks/gameHooks';

const BackHandler =
  Platform.OS === 'android' ? require('react-native').BackHandler : null;

const isX = isIphoneX();

const huntRoutes = [
  'HuntIntro',
  'ClassicIntro',
  'NavigationChallenge',
  'NavigationScore',
  'LocationComplete',
  'LocationChallenges',
  'LocationChallengeScore',
  'TeamPhoto',
];

const classicRoutes = ['Classic', 'TeamPhoto', 'ClassicChallenges'];

const HuntTabNavigator = () => {
  console.log('HuntTabNavigator_v2 tab rerender');

  const {width} = useWindowDimensionsSafe();

  const groupInfo = useSelector((state) => state.groupInfo) || {};

  const userId = useSelector((state) => state.user?.userId);
  const userGroupId = useSelector(
    (state) => state.user?.info?.currentHuntInfo?.groupId,
  );

  const [hideFooter, setHideFooter] = useState(0);

  const dispatch = useDispatch();

  const handleBackButton = () => {
    return true;
  };

  // adding handler for screen effects like hiding the keyboard
  useEffect(() => {
    // back press

    var backHandler;
    if (BackHandler && Platform.OS == 'android') {
      try {
        backHandler = BackHandler?.addEventListener?.(
          'hardwareBackPress',
          handleBackButton,
        );
      } catch (e) {
        console.log('could not add back handler');
      }
    }

    const keyboardDidShowListener = Keyboard?.addListener(
      'keyboardDidShow',
      () => setHideFooter(1),
    );
    const keyboardDidHideListener = Keyboard?.addListener(
      'keyboardDidHide',
      () => setHideFooter(0),
    );

    return () => {
      Keyboard?.removeEventListener?.(keyboardDidShowListener);
      Keyboard?.removeEventListener?.(keyboardDidHideListener);
      backHandler?.remove?.();
    };
  }, []);

  const locationChallengeData =
    useFirebaseData(
      `scavengerhunt/completions/${userGroupId}/location_v2`,
      null,
      null, // no order by
      null, // no order by
      false, // show logs
      !userGroupId, // hide if no group id
    ) || {};

  useEffect(() => {
    console.log('location challenge data update', {
      locationChallengeDataKeys: Object.keys(locationChallengeData || {}),
    });
    locationChallengeData &&
      dispatchAction(setLocationChallengeData(locationChallengeData));
  }, [locationChallengeData]);

  useFirebaseData(
    `scavengerhunt/completions/${userGroupId}/treasure`,
    (treasureChallengesData) => {
      console.log('ltreasureChallengesData update');
      dispatch(updateTreasureChallengeData(treasureChallengesData));
    },
    null, // no order by
    null, // no order by
    false, // show logs
    !userGroupId, // hide if no group id
  );

  useFirebaseData(
    `scavengerhunt/completions/${userGroupId}/anytimePhotos`,
    async (anytimePhotosData = {}) => {
      console.log('updateAnytimePhotosData update');
      dispatch(updateAnytimePhotosData(Object.values(anytimePhotosData)));
    },
    null, // no order by
    null, // no order by
    false, // show logs
    !userGroupId, // hide if no group id
  );

  useFirebaseData(
    `scavengerhunt/groups/${userGroupId}`,
    async (groupData = {}) => {
      console.log('settingGroupPhotos update');
      dispatch(setGroupInfo(groupData));
      dispatch(setCurrentGroupId(groupData?.groupId));
    },
    null, // no order by
    null, // no order by
    false, // show logs
    !userGroupId, // hide if no group id
  );

  useFirebaseData(
    `scavengerhunt/completions/${userGroupId}/player`,
    async (playerChallengesData = {}) => {
      console.log('playerChallengesData update');
      const parsedData = parsePlayerChallegeData(playerChallengesData);
      dispatch(updatePlayerChallengeData(parsedData));
    },
    'parentUserId', // order by parent user id
    userId, // equal to my user id
    false, // show logs
    !userGroupId, // hide if no group id
  );

  const completionPercent = usePercentageComplete();

  const playerChallengeDataActiveCount = useSelector(
    (state) => state?.game?.playerChallengeDataActiveCount,
  );

  const buttonStyle = {marginTop: 5};
  const tabBarHeight = isX ? 75 : 70;

  const percentageCompleteWidth = (completionPercent / 100) * width || 0;

  console.log('hunt tab navigator deciding to render');

  // adding handler for screen effects like hiding the keyboard
  useEffect(() => {
    // back press
    const backHandler = BackHandler?.addEventListener?.(
      'hardwareBackPress',
      handleBackButton,
    );
    const keyboardDidShowListener = Keyboard?.addListener(
      'keyboardDidShow',
      () => setHideFooter(1),
    );
    const keyboardDidHideListener = Keyboard?.addListener(
      'keyboardDidHide',
      () => setHideFooter(0),
    );

    return () => {
      Keyboard?.removeEventListener?.(keyboardDidShowListener);
      Keyboard?.removeEventListener?.(keyboardDidHideListener);
      backHandler?.remove?.();
    };
  }, []);

  const onPageWithNoFooter = useSelector((state) => {
    const currentScreen = state?.current_screen?.currentScreen;
    return [
      'HuntFinishedPlayer',
      'HuntPhotos',
      'HuntPostCard',
      'HuntPostCardAddressConfirmModal',
      'HuntFinished',
      'HuntLoading',
      'ScavengerHuntGameLobby',
      'ScavengerHuntCharacterSelection',
    ]?.includes?.(currentScreen);
  });

  if (hideFooter || onPageWithNoFooter || 1) {
    return <View />;
  }

  return (
    <BottomTab height={tabBarHeight} tabStyle={{alignItems: 'flex-start'}}>
      <View
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: 3,
          backgroundColor: global?.color?.orange,
          width: percentageCompleteWidth,
          borderTopRightRadius: 2,
          borderBottomRightRadius: 2,
        }}
      />
      {!groupInfo?.classic_hunt && (
        <BottomTabButton
          text={'Hunt'}
          iconName={'compass'}
          handlePress={() => {
            // handleRedirect();
            if (global.handleNext) {
              global.handleNext(1);
            } else {
              navigationRef.navigate('HuntLoading');
            }
          }}
          buttonStyle={buttonStyle}
          activeScreenNames={huntRoutes}
        />
      )}
      {!!groupInfo?.classic_hunt && (
        <BottomTabButton
          text={'Hunt'}
          iconName={'compass'}
          handlePress={() => {
            !groupInfo?.groupPhoto
              ? navigationRef.navigate('TeamPhoto')
              : navigationRef.navigate('ClassicChallenges');
          }}
          buttonStyle={buttonStyle}
          activeScreenNames={classicRoutes}
        />
      )}
      {!groupInfo?.indoor_hunt && (
        <BottomTabButton
          text={'Challenges'}
          iconName={'trophy'}
          handlePress={() => navigationRef.navigate('PlayerTreasureChallenges')}
          buttonStyle={buttonStyle}
          activeScreenName={'PlayerTreasureChallenges'}
          badge={playerChallengeDataActiveCount}
        />
      )}
      <BottomTabButton
        text={'Dashboard'}
        iconName={'grid'}
        handlePress={() => navigationRef.navigate('PlayerDashboard_v2')}
        activeScreenName={'PlayerDashboard_v2'}
        buttonStyle={buttonStyle}
      />

      <BottomTabButton
        text={'Camera'}
        iconName={'camera'}
        handlePress={() => {
          navigationRef.navigate('PhotoVideoCamera', {
            onCapture: (data) => {
              const completionObj = {
                ...data,
              };
              anyTimePhotoCompletion(completionObj, groupInfo);
            },
            photoUrl: null,
            shareUUID: null,
            text: 'Capture a moment along your adventure! #WanderWithPurpose',
            isVideo: false,
            isAnytime: true,
          });
        }}
        buttonStyle={buttonStyle}
      />

      <BottomTabButton
        text={'Report'}
        iconName={'flag'}
        handlePress={() => navigationRef.navigate('ReportModal')}
        buttonStyle={buttonStyle}
        active={false}
      />
    </BottomTab>
  );
};

export default HuntTabNavigator;
